import React from 'react';
import Modal from '@material-ui/core/Modal';
import './SuccessModal.css';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import Button from '@mui/material/Button';

const SuccessModal = ({ isOpen, message, onConfirm, btnMessage }) => {
    return (
        <Modal open={isOpen} onClose={onConfirm}>
            <div className="success-modal-box">
                <div className="container">
                    <div className='row'>
                        <div className='col-12 text-center'>
                            <CheckCircleRoundedIcon className='success-icon' />
                        </div>
                        <div className='col-12 text-center'>
                            <h2>Success</h2>
                            <p>{message}</p>
                            <div>
                                <Button className='success-buttons theme-bg' variant="contained" color="primary" onClick={onConfirm}>
                                    <span className='text-trans-none'>{btnMessage}</span>
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default SuccessModal;
